/**
 * @Description: 素材详情页
 * @author zhaijiayu
 * @date 2021/8/25
*/
<template>
  <div class="material-detail-container">
    <!--    面包屑导航-->
    <section class="page-nav">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/material/1' }"
          >素材</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/material/0' }"
          >我的素材</el-breadcrumb-item
        >
        <el-breadcrumb-item>素材详情</el-breadcrumb-item>
      </el-breadcrumb>
    </section>
    <section class="detail-area">
      <div class="detail-content">
        <div class="source-container">
          <video-player
            v-if="materialDetail.cm_type == 3"
            :source="materialDetail.cm_url"
            :cover="materialDetail.cm_icon_url"
            :width="600"
            ratio="2:1"
          />
          <el-image
            v-else
            class="main-img"
            fit="contain"
            :src="materialDetail.cm_url"
            :preview-src-list="[materialDetail.cm_url]"
          />
        </div>
        <div class="detail-info">
          <span>上传时间：{{ materialDetail.update_time }}</span>
          <span>上传人：{{ materialDetail.nick_name }}</span>
          <span
            >大小：{{ Math.floor(materialDetail.size / 1024) || "" }}kb</span
          >
          <span>
            <material-action-bar
              :material-detail="materialDetail"
              :refresh-list="handleOperation"
            />
          </span>
        </div>
      </div>
      <p class="detail-title">{{ materialDetail.cm_title }}</p>
      <p class="detail-desc">{{ materialDetail.describe || "" }}</p>
    </section>
    <!--    使用详情和修订记录-->
    <detail-extra
      :logs="materialDetail.logs"
      :manuscript="materialDetail.manuscript"
    />
  </div>
</template>
<script>
import tools from "../../utils/tools";
import { RESOURCE_HOST } from "../../constants/apiHosts";

import detailExtra from "./components/detail-extra";
import actionBar from "./components/action-bar";
import videoPlayer from "../../components/video-player";

export default {
  name: "materialDetail",
  components: {
    DetailExtra: detailExtra,
    MaterialActionBar: actionBar,
    videoPlayer,
  },
  data: function () {
    return {
      materialId: "",
      materialDetail: {},
    };
  },
  created() {
    // 通过路由参数myset来处理进行展示的素材范围
    const qs = tools.parseQueryString(location.href.split("?")[1] ?? "");
    if (qs.materialId) {
      this.materialId = qs.materialId;
    }
  },
  async mounted() {
    await this.getMaterialDetail();
  },
  methods: {
    /**
     * 获取素材详情
     */
    getMaterialDetail: async function () {
      try {
        const { data } = await this.$axios(
          `${RESOURCE_HOST}/api/material/showChild`,
          {
            method: "POST",
            data: {
              id: this.materialId,
            },
          }
        );
        this.materialDetail = this.formatData(data.data);
      } catch (e) {
        console.error(e);
      }
    },
    formatData: function (originData) {
      return {
        ...originData,
        describe: originData.other?.describe,
      };
    },
    /**
     * 返回列表页
     */
    back: function () {
      this.$router.push({ name: "material" });
    },
    /**
     * 操作点击后回调
     * @param isDelete 是否是删除操作
     */
    handleOperation: function (isDelete = false) {
      if (isDelete) this.back();
      this.getMaterialDetail();
    },
  },
};
</script>
<style scoped lang="scss">
.material-detail-container {
  padding-bottom: 50px;
  .page-nav {
    margin: 18px 20px;

    .fn-btn {
      float: right;
      margin-right: 20px;
      width: 100px;
    }
  }
  .detail-area {
    background: #fff;
    margin: 10px 20px 20px;
    padding: 10px 20px;

    .detail-content {
      display: flex;

      .source-container {
        text-align: center;
        padding: 20px 20px 20px 0;

        .main-img {
          width: 600px;
          height: 300px;
        }
      }

      .detail-info {
        margin-top: 10px;

        > span {
          padding: 10px 0;
          display: block;
        }
      }
    }
    .detail-title {
      padding: 0 0 10px;
    }

    .detail-desc {
      padding: 10px 0;
    }
  }
  /deep/.material-container-extra {
    .el-tabs__header {
      margin-bottom: 0;

      .el-tabs__nav-wrap::after {
        height: 0;
      }
    }
  }
}
</style>